import React from 'react';
import {connect} from 'react-redux';
import {fetchResults} from './../actions';

class FilterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      tags: []
    };
    this.handelQuerytest = this.handelQuerytest.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handelQuerytest() {
    let q = this.props.query;
    this.props.dispatch(fetchResults(q));
  }

  handleChange(tags) {
    this.setState({tags});
  }

  render() {
    return (
      <div>
        {/*<Panel bsStyle="primary" className="searchControlPanel">
         <div className="block" style={{'float': 'right' }}>
         <label style={{'display': 'inline-block'}}>Sorteer op</label>
         <select style={{'display': 'inline-block'}} className="form-control" title="Sorteer op" id="sortDropDown">
         <option value="1">Gelijkenis met zoekvraag</option>
         <option value="2">Nieuwste eerst</option>
         <option value="3">Oudste eerst</option>
         </select>
         </div>
         </Panel>	*/}
      </div>
    );
  }
}

FilterPanel.propTypes = {
  query: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  const {searchresults} = state;
  const {items, query} = searchresults;
  return {
    items,
    query
  };
}

export default connect(mapStateToProps)(FilterPanel);



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/FilterPanel.js
 **/